import React, { ReactNode } from 'react';

import { Asterisk, Label } from './Wrapper.styled';

interface IFieldLabel {
  label: string;
  name: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  hasError?: boolean;
  tooltip?: ReactNode;
  fontSize?: string;
  paddingLabel?: string;
  visibility?: string;
  justifyContent?: string;
  style?: React.CSSProperties;
}

export const FieldLabel = ({
  label,
  name,
  isRequired = false,
  hasError = false,
  isDisabled = false,
  tooltip,
  fontSize,
  paddingLabel,
  visibility,
  justifyContent,
  style,
}: IFieldLabel) => {
  return (
    <>
      {label && (
        <Label
          $hasError={hasError}
          htmlFor={name}
          $tooltip={tooltip}
          $fontSize={fontSize}
          $paddingLabel={paddingLabel}
          $visibility={visibility}
          $justifyContent={justifyContent}
          style={style}
        >
          {isRequired && <Asterisk $isDisabled={isDisabled}>*</Asterisk>} {label} {tooltip}
        </Label>
      )}
    </>
  );
};
